import React, { useEffect, useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import "./DashboardTentor.css";

export default function TentorLayout() {
  const navigate = useNavigate();
  const location = useLocation();

  const [user, setUser] = useState(null);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    try {
      const token = localStorage.getItem("token");
      const userStorage = localStorage.getItem("user");

      if (!token || !userStorage) {
        navigate("/login", { replace: true });
        return;
      }

      const userLogin = JSON.parse(userStorage);

      if (!userLogin || userLogin.role?.toLowerCase() !== "tentor") {
        navigate("/login", { replace: true });
        return;
      }

      setUser(userLogin);
    } catch (error) {
      console.error("ERROR USER LOGIN:", error);

      localStorage.removeItem("user");
      localStorage.removeItem("token");
      localStorage.removeItem("role");
      localStorage.removeItem("user_id");
      localStorage.removeItem("tentor");
      localStorage.removeItem("tentor_id");

      navigate("/login", { replace: true });
    }
  }, [navigate]);

  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    const handleEscape = (event) => {
      if (event.key === "Escape") {
        setMobileMenuOpen(false);
      }
    };

    document.addEventListener("keydown", handleEscape);

    return () => {
      document.removeEventListener("keydown", handleEscape);
    };
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    localStorage.removeItem("role");
    localStorage.removeItem("user_id");
    localStorage.removeItem("tentor");
    localStorage.removeItem("tentor_id");

    navigate("/login", { replace: true });
  };

  const handleNavigation = (path) => {
    setMobileMenuOpen(false);
    navigate(path);
  };

  const isDashboard =
    location.pathname === "/dashboard-tentor" ||
    location.pathname === "/dashboard-tentor/";

  const isJadwal =
    location.pathname === "/jadwal-tentor" ||
    location.pathname.startsWith("/jadwal-tentor/");

  const isAbsensi =
    location.pathname === "/absensi-tentor" ||
    location.pathname.startsWith("/absensi-tentor/");

  if (!user) {
    return (
      <div className="tentor-loading">
        <h2>Memuat Dashboard...</h2>
        <p>Silakan tunggu sebentar.</p>
      </div>
    );
  }

  return (
    <div className="tentor-layout">
      <aside
        className={`tentor-sidebar ${mobileMenuOpen ? "mobile-open" : ""}`}
      >
        <div className="sidebar-logo">
          <h2>BimbelKu</h2>
          <p>Panel Tentor</p>

          <button
            type="button"
            className="tentor-sidebar-close"
            onClick={() => setMobileMenuOpen(false)}
            aria-label="Tutup menu"
          >
            ✕
          </button>
        </div>

        <div className="sidebar-user">
          <div className="avatar">
            {(user.nama || user.name || "T").charAt(0).toUpperCase()}
          </div>

          <div className="sidebar-user-info">
            <h4>{user.nama || user.name || "Tentor"}</h4>
            <span>{user.email || "tentor"}</span>
          </div>
        </div>

        <nav className="sidebar-menu">
          <button
            type="button"
            className={isDashboard ? "active" : ""}
            onClick={() => handleNavigation("/dashboard-tentor")}
          >
            <span>🏠</span>
            <span>Dashboard</span>
          </button>

          <button
            type="button"
            className={isJadwal ? "active" : ""}
            onClick={() => handleNavigation("/jadwal-tentor")}
          >
            <span>📅</span>
            <span>Jadwal Mengajar</span>
          </button>

          <button
            type="button"
            className={isAbsensi ? "active" : ""}
            onClick={() => handleNavigation("/absensi-tentor")}
          >
            <span>📝</span>
            <span>Absensi Siswa</span>
          </button>
        </nav>

        <button type="button" className="logout-btn" onClick={handleLogout}>
          <span>🚪</span>
          <span>Logout</span>
        </button>
      </aside>

      {mobileMenuOpen && (
        <div
          className="tentor-sidebar-overlay"
          onClick={() => setMobileMenuOpen(false)}
        />
      )}

      <main className="tentor-main">
        <div className="topbar">
          <button
            type="button"
            className="tentor-mobile-menu-btn"
            onClick={() => setMobileMenuOpen(true)}
            aria-label="Buka menu"
            aria-expanded={mobileMenuOpen}
          >
            ☰
          </button>

          <div className="topbar-title">
            <h3>
              {isDashboard && "Dashboard"}
              {isJadwal && "Jadwal Mengajar"}
              {isAbsensi && "Absensi Siswa"}
            </h3>

            <p>Sistem Informasi Bimbingan Belajar</p>
          </div>
        </div>

        <Outlet />
      </main>
    </div>
  );
}
